import React from 'react';
import { useHistory } from 'react-router-dom';
import { EmptyState, Flex } from '@bynder/design-system';
import { Translate, useTranslate } from '@bynder/localization';
import EmptyStateNotFound from '../../assets/empty-state-not-found.svg?raw';
import { ROUTES } from '../../constants/app';
import Can from '../../context/ability';
import {
  GUIDELINES_PERMISSIONS,
  PERMISSION_ENTITIES,
} from '../../helpers/permissions';
import PrimaryButton from '../shared/PrimaryButton';
import { svgtob64 } from '../../helpers/utils';
import FullScreenContainer from '../shared/styled-components/FullScreenContainer';

const GuideNotFound: React.FC = () => {
  const { translate } = useTranslate();
  const history = useHistory();

  return (
    <FullScreenContainer>
      <Flex direction="column" justifyContent="center" alignItems="center">
        <img
          src={svgtob64(EmptyStateNotFound)}
          alt={translate('GUIDE_NOT_FOUND.IMG_ALT')}
        />
        <EmptyState
          title={<Translate id="GUIDE_NOT_FOUND.HEADER_TEXT" />}
          text={<Translate id="GUIDE_NOT_FOUND.PARAGRAPH_TEXT" />}
          actions={
            <Can I={GUIDELINES_PERMISSIONS.VIEW} a={PERMISSION_ENTITIES.GUIDE}>
              <Flex justifyContent="center">
                <PrimaryButton
                  onClick={() => history.push(ROUTES.GUIDE_OVERVIEW)}
                >
                  <Translate id="GUIDE_NOT_FOUND.BUTTON_TEXT" />
                </PrimaryButton>
              </Flex>
            </Can>
          }
        />
      </Flex>
    </FullScreenContainer>
  );
};

export default GuideNotFound;
